import { useMemo } from 'react';

import ReportCard from 'components/charts/ReportCard';

import useAccessControl from 'hooks/useAccessControl';

import PATHS from 'utils/paths';

import * as S from '../Reports/Reports.styled';

/**
 * @author @omerrkosar
 */

const OrderReports = () => {
	const isAuthorized = useAccessControl();
	const orderReports = useMemo(
		() => [
			{
				title: 'orderStatusLogs',
				subTitle: 'orderStatusLogsSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.ORDER_STATUS_LOGS,
				filterArray: [
					{
						label: 'dateInterval',
						component: 'dateInput',
						name: 'date',
						required: true
					}
				]
			},
			{
				title: 'dailyOrderStats',
				subTitle: 'dailyOrderStatsSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.DAILY_ORDER_STATS,
				filterArray: [
					{
						label: 'dateInterval',
						component: 'dateInput',
						name: 'date',
						required: true
					}
				]
			},
			{
				title: 'timeStats',
				subTitle: 'timeStatsSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.TIME_STATS_FOR_OPERATION,
				filterArray: [
					{
						label: 'dateInterval',
						component: 'dateFilter',
						name: 'date',
						required: true
					}
				]
			},
			{
				title: 'timeStats',
				subTitle: 'timeStatsSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.TIME_STATS,
				filterArray: [
					{
						label: 'dateInterval',
						component: 'dateInput',
						name: 'date',
						required: true
					}
				]
			},
			{
				title: 'customerFeedbacks',
				subTitle: 'customerFeedbacksSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.CUSTOMER_FEEDBACKS
			},
			{
				title: 'ordersBySLAReport',
				subTitle: 'ordersBySLAReportSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.SLA_BREACHES_REPORT
			},
			{
				title: 'salesBySKU',
				subTitle: 'salesBySKUSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.SALES_BY_SKU,
				filterArray: [
					{
						label: 'dateInterval',
						component: 'dateInput',
						name: 'date',
						required: true
					}
				]
			},
			{
				title: 'ordersByProductReport',
				subTitle: 'ordersByProductReportSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.ORDERS_BY_PRODUCT_REPORT
			},
			// {
			// 	title: 'agedOrdersReport',
			// 	subTitle: 'agedOrdersReportSubTitle',
			// 	actionLabel: 'generate',
			// 	actionPath: PATHS.AGED_ORDERS_REPORT
			// },
			{
				title: 'resentOrders',
				subTitle: 'resentOrdersSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.RESENT_ORDERS
			},
			{
				title: 'heatmap',
				subTitle: 'heatmapSubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.ORDER_HEATMAP
			},
			{
				title: 'customReport1',
				subTitle: 'customReport1SubTitle',
				actionLabel: 'generate',
				actionPath: PATHS.CUSTOM_REPORT_1
			}
		],
		[]
	);

	return (
		<S.Container className="row row-cols-1 row-cols-lg-2">
			{orderReports
				.filter((item) => isAuthorized(item.actionPath))
				.map((item, index) => (
					<ReportCard
						key={index}
						title={item.title}
						subTitle={item.subTitle}
						actionPath={item.actionPath}
						actionLabel={item.actionLabel}
						filterArray={item.filterArray}
					/>
				))}
		</S.Container>
	);
};

export default OrderReports;
